import { FC, PropsWithChildren, useContext } from 'react';

import { BrazeMarketingCard } from 'components/features/components/braze-marketing-card';
import { OnShowModalType } from 'components/features/components/braze-marketing-card/types';
import useEffectOnce from 'hooks/use-effect-once';
import { BrazeContext } from 'state/braze';
import { ContentCardTypes } from 'state/braze/types';
import { ContentCard } from 'utils/braze';

import { ClassicContentCard } from './classic';
import { ImageOnlyContentCard } from './image-only';

type CustomContentCardProps = {
  card: ContentCard;
  index: number;
  onShowTermsModal: OnShowModalType;
};

export const CustomContentCard: FC<PropsWithChildren<CustomContentCardProps>> = ({
  card,
  index,
  onShowTermsModal,
}) => {
  const { logContentCardImpression } = useContext(BrazeContext);

  /**
   * Control Cards should'n be displayed, but we need to handle them when logging impressions
   * in an A/B test. These cards are blank, and while they aren’t seen by users, we should still
   * log impressions in order to compare how they perform against non-Control cards.
   */
  useEffectOnce(() => {
    if (card.isControl) {
      logContentCardImpression(card.id);
    }
  });

  if (card.isControl) {
    return null;
  }

  switch (card.type) {
    case ContentCardTypes.CLASSIC:
      return <ClassicContentCard card={card} />;
    case ContentCardTypes.CAPTIONED:
      return (
        <BrazeMarketingCard
          card={card}
          index={index}
          dismissOnTermsUrlNavigation
          onShowTermsModal={onShowTermsModal}
        />
      );
    case ContentCardTypes.IMAGE_ONLY:
      return <ImageOnlyContentCard card={card} />;
    default:
      return null;
  }
};
